import { CalendarDays } from "lucide-react";
import { ui } from "@/content";

export default function PanelBookButton({ onClick }) {
  return (
    <button type="button" onClick={onClick} data-testid="area-panel-book-button" className="np-btn inline-flex h-12 w-full shrink-0 items-center sm:w-auto sm:flex-1 justify-center gap-2 rounded-full bg-amber px-6 text-[15px] font-semibold text-ink hover:bg-amber-deep">
      <CalendarDays className="h-4 w-4" aria-hidden="true" /> {ui.bookCta}
    </button>
  );
}
